import methods from './methods';

export default {
    register: (data, endpoint = '/api/register/') => methods.post(endpoint, data),
    login: (data, endpoint = '/api/token-ext/') => methods.post(endpoint, data),
    passwordReset: (data, endpoint = '/api/password_reset/') => methods.post(endpoint, data),
    passVerifyToken: (data, endpoint = '/api/password_reset/verify_token/ ') => methods.post(endpoint, data),
    passConfirm: (data, endpoint = '/api/password_reset/confirm/') => methods.post(endpoint, data),
};
